/**
 * Printer identity helpers — Chromium may expose name and/or deviceName.
 */

export function printerDeviceId(printer) {
  if (!printer || typeof printer !== 'object') return '';
  return String(printer.deviceName || printer.name || printer.Name || '').trim();
}

export function printerDisplayLabel(printer) {
  if (!printer || typeof printer !== 'object') return '';
  return String(
    printer.displayName ||
      printer.name ||
      printer.deviceName ||
      printer.Name ||
      ''
  ).trim();
}

/**
 * @param {Array<object>} printers
 * @param {string} id
 */
export function findPrinterByDeviceId(printers, id) {
  const want = String(id || '').trim();
  if (!want) return null;
  const list = Array.isArray(printers) ? printers : [];
  // Exact first
  const exact = list.find((p) => {
    const a = String(p?.deviceName || '').trim();
    const b = String(p?.name || '').trim();
    return a === want || b === want;
  });
  if (exact) return exact;
  // Case-insensitive fallback (Windows / Chromium name drift)
  const wantL = want.toLowerCase();
  return (
    list.find((p) => {
      const a = String(p?.deviceName || '')
        .trim()
        .toLowerCase();
      const b = String(p?.name || '')
        .trim()
        .toLowerCase();
      return a === wantL || b === wantL;
    }) || null
  );
}

/**
 * Normalize assignment shape for storage.
 * @param {object} printer
 */
export function normalizePrinterForSave(printer) {
  const deviceName = printerDeviceId(printer);
  if (!deviceName) return null;
  return {
    deviceName,
    displayName: printerDisplayLabel(printer) || deviceName,
    name: deviceName
  };
}
